import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import Bannerfrom from "../../components/bannerfrom";
import BgImg from "../../../images/location_new/uk-mobile/uk_mob_banner.webp";

function Banner({ handleShow }) {
  return (
    <div
      className="service_usa web_dev_service healthcare_banner android_banner uk_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                Top Mobile App Development Company in UK
              </h1>
              <span>Custom, Intuitive Apps for Superior User Engagement</span>
              <p>
                Our{" "}
                <Link to="/uk/mobile-app-development-company-uk">
                  {" "}
                  mobile app development company in the UK{" "}
                </Link>
                develops bespoke, experience-driven applications for start-ups,
                scale-ups, and enterprises. We help you ideate, design, develop,
                and launch high-performing, secure, and accessible applications
                across platforms with end-to-end mobile app development services
                in the UK.
              </p>

              <button
                className="border_btn"
                onClick={handleShow}
                aria-label="TekRevol Contact"
              >
                Start with a Free Consultation
              </button>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
